import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-51f81f6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pb-4 pl-4 text-gray-400"
}
const _hoisted_2 = ["checked"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["checked", "onChange"]
const _hoisted_6 = { key: 0 }

import { onMounted, ref, watch } from "vue";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'AppDatatable',
  props: {
		options: {
			type: Object,
			default: {
				columns: [],
				data: [],
				isLoading: false,
			},
		},
		heightTable: {
			type: String,
			default: "calc(100vh - 20rem)",
		},
		title: {
			type: String,
			default: "",
		},
		styleTable: {
			type: String,
			default: "w-full",
		},
		styleHeader: {
			type: String,
			default: "custum-bg-opacity-40",
		},
		styleRow: {
			type: String,
			default: "rounded-xl",
		},
		emptyTagStyle: {
			type: String,
			default: "",
		},
		dynamicWidth: {
			type: Boolean,
			default: false,
		},
		moreactions: {
			type: Object,
			default: {
				status: {
					type: Boolean,
					default: false,
				},
				style: {
					type: String,
					default: "w-[8%]",
				},
				action_1: {
					type: Object,
					default: {
						status: false,
						icon: "/media/icons/more-actions-icons.svg",
						style: {
							type: String,
							default: "w-6 h-6",
						},
						loading: false,
					},
				},
				action_2: {
					type: Object,
					default: {
						status: false,
						icon: "/media/icons/more-actions-icons.svg",
						style: {
							type: String,
							default: "w-6 h-6",
						},
						loading: false,
					},
				},
				dot_action: {
					type: Object,
					default: {
						status: true,
						options: [],
						onClick: {
							Type: Function,
							default: (data: any) => {
								//
							},
						},
					},
				},
				checkboxs: {
					type: Object,
					default: {
						status: false,
					},
				},
			},
		},
		pagination: {
			type: Object,
			default: () => ({
				current_page: 1,
				last_page: 1,
				per_page: 10,
				total: 0,
			}),
		},
	},
  emits: ["selection-changed", "on-selected", "on-action-1", "on-action-2", "on-page-change", "on-per-page-change"],
  setup(__props, { emit: __emit }) {

	const widthColumns = ref("w-10");
	const height = ref("h-10");
	const selectedRows = ref<Set<any>>(new Set()); // Stocker les lignes sélectionnées
	const isAllSelected = ref(false); // État pour la case "Tout sélectionner"

	// Déclaration des événements que le composant peut émettre
	const emit = __emit;

	/**
	 * Varialbles
	 */
	const props = __props;

	watch(selectedRows.value, () => {
  	emitSelectedRows();
	});

	watch(() => props.options.data, () => {
		selectedRows.value.clear();
		isAllSelected.value = false;
	});

	// Gestion de la sélection/désélection d'une ligne
	function toggleRowSelection(row: any) {
		if (selectedRows.value.has(row)) {
			selectedRows.value.delete(row); // Si déjà sélectionnée, on la retire
		} else {
			selectedRows.value.add(row); // Sinon, on l'ajoute
		}

		// Met à jour l'état de "Tout sélectionner"
		isAllSelected.value = selectedRows.value.size === props.options.data.length;
	}

	// Gestion de la case "Tout sélectionner"
	function toggleAllSelection() {
		if (isAllSelected.value) {
			// Tout désélectionner
			selectedRows.value.clear();
		} else {
			// Tout sélectionner
			props.options.data.forEach((row: any) => selectedRows.value.add(row));
		}
		isAllSelected.value = !isAllSelected.value;
	}

	// Émettre les lignes sélectionnées vers le parent
	function emitSelectedRows() {
		const selectedArray = Array.from(selectedRows.value);
		emit("selection-changed", selectedArray);
	}

	// Émettre l'événement de changement de page
	function changePage(newPage: number) {
		if (newPage !== props.pagination.current_page) {
			emit("on-page-change", newPage);
		}
}

	// Émettre l'événement de changement de PerPage
	function changePerPage(newPage: number) {
		if (newPage !== props.pagination.current_page) {
			emit("on-per-page-change", newPage);
		}
	}

	/**
	 * App Lifecycle
	 */
	onMounted(() => {
		const totalColumns = props.options.columns.length;
		widthColumns.value = totalColumns > 0 ? 100 / totalColumns + "%" : "10";
		// console.log("props.options: ", props.moreactions.action_2.status);
	});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_MoreActionsTag = _resolveComponent("MoreActionsTag")!
  const _component_EmptyTag = _resolveComponent("EmptyTag")!
  const _component_AppDatatableSkeleton = _resolveComponent("AppDatatableSkeleton")!
  const _component_SkeletonLoader = _resolveComponent("SkeletonLoader")!
  const _component_PaginationTag = _resolveComponent("PaginationTag")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			__props.styleTable,
			{ 'flex flex-col text-white': true },
		])
  }, [
    (__props.title != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([
				__props.styleHeader,
				{ 'flex flex-row justify-between p-2  border-b-1 border-white  rounded-xl mr-2': true },
			])
    }, [
      (__props.moreactions?.checkboxs?.status ?? false)
        ? _renderSlot(_ctx.$slots, "checkboxs", { key: 0 }, () => [
            _createElementVNode("input", {
              type: "checkbox",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              checked: isAllSelected.value,
              onChange: toggleAllSelection,
              class: "ml-4"
            }, null, 40, _hoisted_2)
          ])
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options.columns, (column, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([{ 'text-white font-medium text-sm': true, 'pl-2': true }]),
          style: _normalizeStyle({ width: __props.dynamicWidth ? column.width : widthColumns.value }),
          key: index
        }, _toDisplayString(column.label), 5))
      }), 128)),
      (__props.moreactions?.status ?? false)
        ? _renderSlot(_ctx.$slots, "moreactions", { key: 1 }, () => [
            _createElementVNode("span", {
              class: _normalizeClass([__props.moreactions.style ?? 'w-[8%]', { 'mr-4 flex justify-end': true }])
            }, "Actions", 2)
          ])
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: "flex flex-col overflow-y-auto custumScroll",
      style: _normalizeStyle({ height: __props.heightTable })
    }, [
      (!__props.options.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options.data, (row, indexRow) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
						__props.styleRow,
						{
							'items-center border-b border-opacity-10  mmr-2': true,
							'flex flex-row  py-2 px-2 justify-between custum-bg-opacity-20': true,
							'cursor-pointer': true,
						},
					]),
                key: indexRow,
                onClick: ($event: any) => (_ctx.$emit('on-selected', row))
              }, [
                (__props.moreactions?.checkboxs?.status ?? false)
                  ? _renderSlot(_ctx.$slots, "checkboxs", { key: 0 }, () => [
                      _createElementVNode("input", {
                        type: "checkbox",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                        checked: selectedRows.value.has(row),
                        onChange: () => toggleRowSelection(row),
                        class: "ml-4"
                      }, null, 40, _hoisted_5)
                    ])
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options.columns, (column, indexColumn) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass([column.style, { 'text-gray-400': true , 'pl-2 pr-4': false }]),
                    style: _normalizeStyle({ width: __props.dynamicWidth ? column.width : widthColumns.value }),
                    key: indexColumn
                  }, [
                    _renderSlot(_ctx.$slots, column.name, {
                      data: row,
                      index: indexRow
                    }, () => [
                      _createTextVNode(_toDisplayString(row[column.name]), 1)
                    ])
                  ], 6))
                }), 128)),
                (__props.moreactions?.status ?? false)
                  ? _renderSlot(_ctx.$slots, "more-actions", {
                      key: 1,
                      data: row,
                      index: indexRow
                    }, () => [
                      _createElementVNode("div", {
                        class: _normalizeClass([
								__props.moreactions.style ?? 'w-[8%]',
								__props.moreactions.stylerow ?? '',
								{ 'flex justify-end ': true },
							])
                      }, [
                        (__props.moreactions?.action_1?.status ?? false)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              (!(__props.moreactions?.action_1?.loading ?? false))
                                ? (_openBlock(), _createBlock(_component_Icon, {
                                    key: 0,
                                    src: __props.moreactions?.action_1?.icon ?? '/media/icons/more-actions-icons.svg',
                                    css: __props.moreactions?.action_1?.style ?? 'w-6 h-6',
                                    onClick: _withModifiers(($event: any) => (_ctx.$emit('on-action-1', row)), ["stop"])
                                  }, null, 8, ["src", "css", "onClick"]))
                                : _createCommentVNode("", true),
                              (__props.moreactions?.action_1?.loading ?? false)
                                ? (_openBlock(), _createBlock(_component_Spinner, {
                                    key: 1,
                                    width_: "15px",
                                    height_: "20px",
                                    width: "1px",
                                    height: "12px",
                                    color: "#fff"
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (__props.moreactions?.action_2?.status ?? false)
                          ? (_openBlock(), _createBlock(_component_Icon, {
                              key: 1,
                              src: __props.moreactions?.action_2?.icon ?? '/media/icons/more-actions-icons.svg',
                              css: __props.moreactions?.action_2?.style ?? 'w-6 h-6',
                              onClick: _withModifiers(($event: any) => (_ctx.$emit('on-action-2', row)), ["stop"])
                            }, null, 8, ["src", "css", "onClick"]))
                          : _createCommentVNode("", true),
                        (__props.moreactions?.dot_action?.status ?? false)
                          ? (_openBlock(), _createBlock(_component_MoreActionsTag, {
                              key: 2,
                              options: __props.moreactions?.dot_action?.options ?? [],
                              onClick: (data, clickedOptionName, clickedOptionSubName) => __props.moreactions?.dot_action?.onClick && __props.moreactions.dot_action.onClick(data, clickedOptionName, clickedOptionSubName),
                              styleSubMenu: "left-[-125px]",
                              data: row
                            }, null, 8, ["options", "onClick", "data"]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ])
                  : _createCommentVNode("", true)
              ], 10, _hoisted_4))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (__props.options.data.length == 0 && !__props.options.isLoading)
        ? (_openBlock(), _createBlock(_component_EmptyTag, {
            key: 1,
            styleAsset: __props.emptyTagStyle,
            height: __props.heightTable
          }, null, 8, ["styleAsset", "height"]))
        : _createCommentVNode("", true),
      (__props.options.isLoading)
        ? (_openBlock(), _createBlock(_component_SkeletonLoader, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_AppDatatableSkeleton, { stats: 6 })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 4),
    _createVNode(_component_PaginationTag, {
      meta: props.pagination.meta,
      onPageChange: changePage,
      onPerPageChange: changePerPage
    }, null, 8, ["meta"])
  ], 2))
}
}

})